<p>average-cost-movement works!</p>
